import React from 'react';
import classNames from 'classnames';

const StepSeparator = ({ isCompleted }: { isCompleted: boolean }) => {
  return (
    <div
      className={classNames(
        `h-[3px] bg-gray-400 bg-gradient-to-l from-gray-400 to-blue-light from-50% to-50% bg-[length:200%]
        bg-[right] transition-all duration-400 ease-in-out flex-1`,
        {
          '!bg-[left]': isCompleted,
        },
      )}
    />
  );
};

export default StepSeparator;
